import React from 'react';
import ResizeableSidebar from '@/components/ResizeableSidebar';
import { useDataPresentationParam } from '@/hooks';
import { QueryConfigSidebar } from '@/features/queryConfig/components/QueryConfigSidebar';

export const DataPresentationConfigurationSidebar = () => {
  const isVisible = !!useDataPresentationParam();

  return (
    <ResizeableSidebar
      initialWidth={375}
      isVisible={isVisible}
      isRightSidebar
      withToggleButton
    >
      <QueryConfigSidebar showOnboarding={isVisible} />
    </ResizeableSidebar>
  );
};
